import React from 'react';
import useCreateGoalForDomain from '@/hooks/growthzone/useCreateGoalForDomain';
import { GOAL_HEIGHT } from './GrowthZoneDomainItem';
import { THealthDomainWithOverall } from '@/types/Health.types';
import { Center } from '@chakra-ui/react';
import LogoSpinner from '@/components/atoms/LogoSpinner';
import { MAX_CHARS_IN_GOAL, MIN_CHARS_IN_GOAL } from '@/constants';
import InlineAddTextField from '@/components/atoms/InlineAddTextField';

interface Props {
  domain: THealthDomainWithOverall;
  placeholder: string;
  refetchAllGoals: () => void;
  hasJustAddedAGoalIndex: number;
  setHasJustAddedAGoalIndex: React.Dispatch<React.SetStateAction<number>>;
  index: number;
}

const GrowthZoneCreate = ({
  domain,
  placeholder,
  refetchAllGoals,
  hasJustAddedAGoalIndex,
  setHasJustAddedAGoalIndex,
  index,
}: Props) => {
  const { mutate: createNewGoal, isPending: isCreateGoalPending } = useCreateGoalForDomain(domain, () => {
    refetchAllGoals();
  });

  const onSubmitCreateDomainGoal = (newText: string) => {
    const goalTooShort = !newText?.length || newText.length < MIN_CHARS_IN_GOAL;
    const goalTooLong = newText?.length && newText.length > MAX_CHARS_IN_GOAL;

    if (!goalTooShort && !goalTooLong) {
      setHasJustAddedAGoalIndex(index);
      createNewGoal(newText);
    }
  };

  if (isCreateGoalPending || hasJustAddedAGoalIndex === index) {
    return (
      <Center paddingY={'10px'}>
        <LogoSpinner isLoading size={`${GOAL_HEIGHT - 20}px`} />
      </Center>
    );
  }

  return (
    <InlineAddTextField
      placeholder={placeholder}
      minChars={MIN_CHARS_IN_GOAL}
      maxChars={MAX_CHARS_IN_GOAL}
      minHeight={GOAL_HEIGHT}
      onSubmit={onSubmitCreateDomainGoal}
    />
  );
};

export default GrowthZoneCreate;
